import React from 'react'
import { useSelector } from 'react-redux';
import './BillTypeTemplateSummaryThermal.css';

const TaxDetailsPrint = () => {

    const decimalPosition = localStorage.getItem("decimalPosition");
    const ShiftBillTypeSummary = useSelector((state) => state.posReportshiftSlice.taxDetails);
    const {showSubHeaders} = useSelector((state) => state.posReportshiftSlice);
    const total =
    (ShiftBillTypeSummary?.dineIn?.totalTax || 0) +
    (ShiftBillTypeSummary?.takeAway?.totalTax || 0) +
    (ShiftBillTypeSummary?.delivery?.totalTax || 0);

  return (
     <div
      className="thermal-receipt-container">
      <div className="bill-main-head">
        <h5>Tax Details</h5>
        <h5>Tax Amount</h5>
      </div>
      <div
        className="bill-sub-head">
        <h5>Dine In</h5>
        <h5>
          {(ShiftBillTypeSummary?.dineIn?.totalTax || 0)?.toFixed(decimalPosition)}
        </h5>
      </div>
      {showSubHeaders && (
        <table>
          <thead>
            <tr>
              <th>O/ID</th>
              <th>Tax</th>
              <th>O Amt</th>
              <th>Tax Amt</th>
            </tr>
          </thead>
          <tbody>
            {(ShiftBillTypeSummary?.dineIn?.data !== undefined && ShiftBillTypeSummary?.dineIn?.data.length!==0) ? (
              ShiftBillTypeSummary?.dineIn?.data?.map((r, i) => (
                <tr key={i}>
                  <td>
                    {r?.name}
                  </td>
                  <td>
                    {r.taxName}
                  </td>
                  <td>
                    {r?.amtTotal?.toFixed(decimalPosition)}
                  </td>
                  <td>
                    {r?.taxAmount?.toFixed(decimalPosition)}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={8}>NO DATA</td>
              </tr>
            )}
          </tbody>
        </table>
      )}
      <div className="bill-sub-head">
        <h5>Take Away</h5>
        <h5>
          {(ShiftBillTypeSummary?.takeAway?.totalTax || 0)?.toFixed(decimalPosition)}
        </h5>
      </div>
      {showSubHeaders && (
        <table>
              <thead>
            <tr>
              <th>O/ID</th>
              <th>Tax</th>
              <th>O Amt</th>
              <th>Tax Amt</th>
            </tr>
          </thead>
         <tbody>
         {(ShiftBillTypeSummary?.takeAway?.data !== undefined && ShiftBillTypeSummary?.takeAway?.data.length!==0) ? (
           ShiftBillTypeSummary?.takeAway?.data?.map((r, i) => (
             <tr key={i}>
               <td>
                 {r.name}
               </td> 
               <td>
                 {r.taxName}
               </td>
               <td>
                    {r.amtTotal?.toFixed(decimalPosition)}
                  </td>
                  <td>
                    {r.taxAmount?.toFixed(decimalPosition)}
                  </td>
             </tr>
           ))
         ) : (
           <tr>
             <td colSpan={8}>NO DATA</td>
           </tr>
         )}
       </tbody>
       </table>
      )}
      <div className="bill-sub-head">
        <h5>Delivery</h5>
        <h5>
          {(ShiftBillTypeSummary?.delivery?.totalTax || 0)?.toFixed(decimalPosition)}
        </h5>
      </div>
      {showSubHeaders && (
        <table>
          <thead>
            <tr>
              <th>O/ID</th>
              <th>Tax</th>
              <th>O Amt</th>
              <th>Tax Amt</th>
            </tr>
          </thead>
          <tbody>
            {(ShiftBillTypeSummary?.delivery?.data !== undefined && ShiftBillTypeSummary?.delivery?.data.length!==0) ? (
              ShiftBillTypeSummary?.delivery?.data?.map((r, i) => (
                <tr key={i}>
                  <td>
                    {r?.name}
                  </td>
                  <td>
                    {r?.taxName}
                  </td>
                  <td>
                    {r?.amtTotal?.toFixed(decimalPosition)}
                  </td>
                  <td>
                    {r?.taxAmount?.toFixed(decimalPosition)}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={8}>NO DATA</td>
              </tr>
            )}
          </tbody>
        </table>
      )}
       <div className="bill-main-head">
        <h5>Total Tax</h5>
        <h5>{total?.toFixed(decimalPosition)}</h5>
      </div>
    </div>
  )
}

export default TaxDetailsPrint